import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageView } from '../utils/analytics';

/**
 * Mounts once inside <BrowserRouter>. Initializes analytics on first render
 * and fires a PageView on every route change.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    initAnalytics().then(() => {
      if (!cancelled) trackPageView(location.pathname + location.search);
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
